"use client";

import Image from "next/image";
import { useEffect, useRef } from "react";
import gsap from "gsap";

const clients = [
  { id: 1, client: "/clients/access.png" },
  { id: 2, client: "/clients/apa.png" },
  { id: 3, client: "/clients/baringo.png" },
  { id: 4, client: "/clients/family-bank.png" },
  { id: 5, client: "/clients/heritage.png" },
  { id: 6, client: "/clients/kenya-alliance.png" },
  { id: 7, client: "/clients/kwft.png" },
  { id: 8, client: "/clients/nkr.png" },
  { id: 9, client: "/clients/sanlam.png" },
];

export default function AboutSection2() {
  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sliderRef.current) return;

    const slider = sliderRef.current;
    const sliderWidth = slider.scrollWidth / 2;

    const tl = gsap.timeline({ repeat: -1 });

    tl.to(slider, {
      x: -sliderWidth,
      duration: 20,
      ease: "none",
    }).set(slider, { x: 0 });

    return () => tl.kill();
  }, []);

  return (
    <section className="w-full bg-primary/20 py-2 md:py-4">
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 w-full px-4 md:px-10">

        {/* Slider */}
        <div className="relative overflow-hidden w-full h-[40px] md:h-[60px]">
          <div
            ref={sliderRef}
            className="flex items-center gap-10 md:gap-20 whitespace-nowrap"
          >
            {[...clients, ...clients].map((item, index) => (
              <div
                key={`${item.id}-${index}`}
                className="relative flex items-center justify-center h-[80px] md:h-[90px] w-[100px] md:w-[150px] flex-shrink-0"
              >
                <Image
                  src={item.client}
                  alt="client-logo"
                  fill
                  className="object-contain"
                  sizes="(max-width: 768px) 80px, 120px"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
